import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 日志定义
 */
export class LogDef extends UltMeta {
    /**
     * 功能模块
     */
    // 用户管理 - 用户详情
    USER_INFO = new Meta(1, "用户详情");
    // 采销管理 - 销售管理 - 订单详情
    ORDER_INFO = new Meta(2, "订单详情");
    // 采销管理 - 销售管理 - 签收详情
    RECEIPT_INFO = new Meta(3, "签收详情");
    // 采销管理 - 销售管理 - 结算详情
    RECONCILIATION_INFO = new Meta(4, "结算详情");
    // 采销管理 - 销售管理 - 开票详情
    INVOICE_INFO = new Meta(5, "开票详情");
    // 资金管理 - 额度变更 - 额度变更详情
    CREDIT_LIMIT_CHANGE_INFO = new Meta(6, "额度变更详情");
    // 合同管理 - 合同详情
    CONTRACT_INFO = new Meta(7, "合同详情");
    // 项目管理 - 项目详情
    PROJECT_INFO = new Meta(8, "项目详情");
    // 收款管理 - 收款详情
    PAYMENT_INFO = new Meta(9, "收款详情");
    // 退款管理 - 退款详情
    REFUND_INFO = new Meta(10, "退款详情");
    // 应收款管理 - 应收款详情
    ACCOUNTS_INFO = new Meta(11, "应收款详情");
    // 服务费管理 - 服务费详情
    SERVICE_FEE_INFO = new Meta(12, "服务费详情");
    // 融资管理 - 客户融资详情页
    FINANCING_INFO = new Meta(13, "客户融资详情");
    // 融资管理 - 客户借据列表页
    LOAN_RECEIPT_INFO = new Meta(14, "客户借据列表");
    // 融资管理 - 还款详情页
    REPAYMENT_INFO = new Meta(15, "还款详情");
}

// 导出单例实例
export const LOG_DEF = new LogDef();

export class MessageCardType extends UltMeta {
    /**
     * 消息的类型
     */

    // 订单
    MESSAGE_TYPE_ALL = new Meta(0, "全部");
    // 订单
    MESSAGE_TYPE_ORDER = new Meta(1, "订单");
    // 用户
    MESSAGE_TYPE_USER = new Meta(2, "用户");
    // 签收
    MESSAGE_TYPE_SIGN = new Meta(3, "签收");
    // 结算
    MESSAGE_TYPE_RECONCILIATION = new Meta(4, "结算");
    // 开票
    MESSAGE_TYPE_BILL_PAYMENT = new Meta(5, "开票");
    // 合同
    MESSAGE_TYPE_CONTRACT = new Meta(6, "合同");
    // 服务费
    MESSAGE_TYPE_SERVICE_FEE = new Meta(7, "服务费");
    // 资金
    MESSAGE_TYPE_FUNDING = new Meta(8, "资金");
    // 融资
    MESSAGE_TYPE_FINANCING = new Meta(9, "融资");
    // 贷款
    MESSAGE_TYPE_LOAN_RECEIPT = new Meta(10, "贷款");
    // 还款
    MESSAGE_TYPE_REPAYMENT = new Meta(11, "还款");
}

export const MESSAGE_CARD_TYPE = new MessageCardType();
